import Vue from "vue"
import moment from "moment"

Vue.filter('formatTime', function (value: number, format: any = "YYYY-MM-DD") {
  if (!value) return;
  return moment(new Date(value * 1000)).format(format);
})